// @flow
import React, { useState, useEffect, type Node } from 'react';
import styled from 'styled-components';

import { toDataURL as toQRCodeDataURL } from 'qrcode';
import { getNequiQRCodeValue } from '@tectonics/prs/incoming-payment/get-nequi-qrcode-info';
import { usePendingIncomingPayment } from '@tectonics/prs/incoming-payment';
import { base64toBlob } from '@tectonics/commons/base64-to-blob';

export function NequiQrCode(): Node {

  const incomingPayment = usePendingIncomingPayment();

  const qrCodeValue = getNequiQRCodeValue(incomingPayment);
  const [qrCodeSrc, setQrCodeSrc] = useState();
  
  useEffect(() => {
    (async () => {
      const data = await toQRCodeDataURL(qrCodeValue);
      const base64 = data.substring(data.indexOf(',') + 1);
      const blob = base64toBlob(base64, 'image/png');
      setQrCodeSrc(URL.createObjectURL(blob));
    })();
  }, [qrCodeValue]);

  return (
    <Root>
      <QrCodeImage src={qrCodeSrc} alt={qrCodeValue} />
      <BottomInfo>
        <Link href={qrCodeSrc} download="qrcode.png">
          DESCARGAR QR CODE
        </Link>
      </BottomInfo>
    </Root>
  );
}

const Root = styled.div`
  text-align: center;
  margin-top: 30px;
`;

const QrCodeImage = styled.img`
  border: 2px solid rgba(0,0,0,.1);
  height: 150px;
`;

const BottomInfo = styled.div`
  margin-top: 12px;
`;

const Link = styled.a`
  font-weight: bold;
  text-decoration: none;
  color: rgb(35, 151, 212);

  &:hover {
    filter: brightness(115%);
  }
`;
